/*
  CEBE · "Compare the six." as Apple's compare page: the chosen coffees side by side, two on phones and tablets, three
  from 1001 px (review/apple-perfekt-2026-10-03, R6). Apple puts at most three models next to each other, one selector
  above each column, product view, price and action at the head of the column, the same detail on the same line, and
  keeps the choice in the address (?modelList=…; research/2026-10-03-chatgpt-apple-aufbau/02-APPLE-PRODUKT-KAUF-
  VERGLEICH.md Z. 95-99; 05-CEBE-UEBERTRAGUNG.md Z. 12). Loaded by sections/cebe-compare.liquid with defer.
  - Progressive: without this script the section shows every coffee (one card per coffee up to 1000 px, the table from
    1001 px). The script adds the selectors and marks the section data-pair; the CSS of the section then shows the
    chosen rows as columns, each headed by bag, name (link to the coffee) and price with unit price and VAT line.
  - The choice comes from and goes to ?compare=<handle>,<handle>,<handle> (history.replaceState: no reload, no history
    entry, no cookie, no storage). A product page links to a preselected pair; unknown or missing handles are filled in
    the collection's own order.
  - The chosen rows move to the front of the table in column order, so reading order and screen order agree
    (WCAG 1.3.2). Choosing a coffee that another visible column shows swaps the two columns. No motion.
  - Each selector shows the chosen name in full (it may wrap) above a transparent native select: keyboard, screen reader
    and the phone's own picker stay those of the select.
*/
(function () {
  'use strict';

  function init(section) {
    var table = section.querySelector('.cebe-compare__table');
    var body = table && table.tBodies[0];
    if (!body || !window.URLSearchParams || !window.matchMedia) return;
    var rows = Array.prototype.slice.call(body.querySelectorAll('[data-cebe-compare-row]'));
    if (rows.length < 3) return; // two coffees already sit side by side as cards
    var handles = rows.map(function (row) { return row.getAttribute('data-cebe-compare-row'); });
    var names = rows.map(function (row) { return row.getAttribute('data-cebe-compare-name'); });
    var narrow = window.matchMedia('(max-width: 1000px)');
    var max = Math.min(3, rows.length);

    var wanted = (new URLSearchParams(window.location.search).get('compare') || '').split(',');
    var pick = [];
    wanted.forEach(function (h) {
      var i = handles.indexOf(h);
      if (i >= 0 && pick.indexOf(i) < 0 && pick.length < max) pick.push(i);
    });
    for (var i = 0; pick.length < max && i < handles.length; i++) if (pick.indexOf(i) < 0) pick.push(i);

    function count() { return narrow.matches ? 2 : max; }

    var caption = table.querySelector('caption');
    if (caption) {
      var lede = document.createElement('p');
      lede.className = 'cebe-compare__lede';
      lede.setAttribute('aria-hidden', 'true');
      lede.textContent = caption.textContent;
      table.parentNode.insertBefore(lede, table);
    }

    var pickers = document.createElement('div');
    pickers.className = 'cebe-compare__pickers';
    var labels = [section.getAttribute('data-label-first'), section.getAttribute('data-label-second'), section.getAttribute('data-label-third')];
    var shown = [];
    var selects = labels.slice(0, max).map(function (label, column) {
      var wrap = document.createElement('div');
      wrap.className = 'cebe-compare__pick';
      var name = document.createElement('span');
      name.className = 'cebe-compare__pick-name';
      name.setAttribute('aria-hidden', 'true');
      var select = document.createElement('select');
      select.className = 'cebe-compare__picker';
      select.setAttribute('aria-label', label || '');
      handles.forEach(function (handle, k) {
        var option = document.createElement('option');
        option.value = handle;
        option.textContent = names[k];
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        var chosen = handles.indexOf(select.value);
        if (chosen < 0) return;
        var other = pick.indexOf(chosen);
        if (other >= 0 && other !== column) pick[other] = pick[column];
        pick[column] = chosen;
        apply(true);
      });
      wrap.appendChild(name);
      wrap.appendChild(select);
      pickers.appendChild(wrap);
      shown.push(name);
      return select;
    });
    table.parentNode.insertBefore(pickers, table);
    section.setAttribute('data-pair', '');

    function apply(write) {
      var n = count();
      var visible = pick.slice(0, n);
      section.style.setProperty('--cebe-compare-cols', n);
      rows.forEach(function (row, k) {
        if (visible.indexOf(k) < 0) row.setAttribute('data-cebe-compare-out', '');
        else row.removeAttribute('data-cebe-compare-out');
      });
      selects.forEach(function (select, column) {
        select.value = handles[pick[column]];
        shown[column].textContent = names[pick[column]];
        select.parentNode.hidden = column >= n;
      });
      // Reading order: the chosen coffees first, in column order; the others keep the collection's order after them.
      visible.concat(handles.map(function (h, k) { return k; }).filter(function (k) { return visible.indexOf(k) < 0; }))
        .forEach(function (k) { body.appendChild(rows[k]); });
      if (write && window.history && window.history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        params.set('compare', visible.map(function (k) { return handles[k]; }).join(','));
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString() + window.location.hash);
      }
    }

    if (narrow.addEventListener) narrow.addEventListener('change', function () { apply(false); });
    apply(false);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cebe-compare]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
